import { createReducer } from '@reduxjs/toolkit'

import {
  loggedOutClubOne,
  receivedClubOneDetails,
  selectClubOneTab,
  selectCompanyTab,
  switchToCompanyTab
} from '../actions/actions'

const tabs = {
  clubOne: 'clubOne',
  company: 'company'
}

const initialState = {
  activeTab: tabs.clubOne,
  switchingToCompanyTab: false
}

const clientTypeTab = createReducer(initialState, {
  [selectClubOneTab]: state => {
    state.activeTab = tabs.clubOne
  },
  [selectCompanyTab]: state => {
    state.activeTab = tabs.company
  },
  [switchToCompanyTab]: state => {
    state.switchingToCompanyTab = true
  },
  [loggedOutClubOne]: state => {
    if (state.switchingToCompanyTab) {
      state.activeTab = tabs.company
      state.switchingToCompanyTab = false
    }
  },
  [receivedClubOneDetails]: state => {
    state.activeTab = tabs.clubOne
  }
})

export default clientTypeTab
